/*
 * hook to optimize images based on window width for Sanity and Shopify-sourced images
 * appends params to image src to optimize for webp and width
 * focus mainly on mobile but still optimizes for desktop by using webp format with "auto=format" param
 * (https://www.sanity.io/docs/image-urls and https://www.highviewapps.com/blog/shopify-tip-how-retrieve-product-images-different-sizes-image-url/)
 * params: originalImageSrc (string), initialWindowWidth (string or number)
 */

export function useImageOptimizer(originalImageSrc, initialWindowWidth) {
  // check to see if url comes from Sanity or Shopify and then append params accordingly
  const urlIsShopifySourced = originalImageSrc?.includes('shopify.com');
  const urlAlreadyHasParams = originalImageSrc?.includes('?');
  const paramSymbol = urlAlreadyHasParams ? '&' : '?';
  const widthParmKey = urlIsShopifySourced ? 'width' : 'w';

  const widthParam = initialWindowWidth
    ? `${paramSymbol}${widthParmKey}=${initialWindowWidth.toString()}`
    : '';
  const webpParam = !urlIsShopifySourced
    ? initialWindowWidth || urlAlreadyHasParams
      ? '&auto=format'
      : '?auto=format'
    : '';

  const optimizedImageSrc = originalImageSrc
    ? `${originalImageSrc}${widthParam}${webpParam}`
    : '';

  return {
    optimizedImageSrc,
  };
}
